"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _definitionhelpers = require("../../../utils/definitionhelpers");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// utils

/* ++++++++++ --------------- SOCIAL LINKS: DEFINITION --------------- ++++++++++ */


var _default = {
  name: 'SocialLinks',
  group: _definitionhelpers.groupNames.ctas,
  props: {}
};
exports.default = _default;